/*Modified by Aritra Basak
 */
import * as React from "react";
import Box from "@material-ui/core/Box";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { Modal } from "@material-ui/core";
import { Fade } from "@material-ui/core";
import { Backdrop } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { URI_PREFIX, URI } from "../../constants/index";
import { asyncPost } from "../../common/utils";
import { Link, useNavigate } from "react-router-dom";
import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import "../../assets/styles/GenerateAbhaByAadhaar.css";
import "../../assets/styles/V3.css";
import {
  RESEND_OTP_TIMEOUT,
  RESEND_OTP_CHANCE,
} from "../../constants/dataconstants";

const steps = [
  "Step 1",
  "Step 2",
  "Step 3",
  "Step 4",
  "Step 5",
  "Step 6",
  "Step 7",
];

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(10),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    padding: theme.spacing(5),
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
  },
}));

export default function GenerateAbhaByAadhaar() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [showAadhaar, setShowAadhaar] = React.useState(false);
  const [aadhaarId, setAadhaarId] = React.useState("");
  const [aadhaarOtp, setAadhaarOtp] = React.useState("");
  const [txnId, setTxnId] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [mobileOtp, setMobileOtp] = React.useState("");
  const [healthId, setHealthId] = React.useState("");
  const [patientName, setPatientName] = React.useState("");
  const [healthIdRes, setHealthIdRes] = React.useState("");
  const [healthIdNoRes, setHealthIdNoRes] = React.useState("");
  const [mobileRes, setMobileRes] = React.useState();
  const [genderRes, setGenderRes] = React.useState();
  const [emailRes, setEmailRes] = React.useState();
  const [dobres, setDobRes] = React.useState();
  const [kycPhotoRes, setKycPhotoRes] = React.useState();
  const [profileImageRes, setProfileImageRes] = React.useState();
  const [xToken, setXToken] = React.useState("");
  const [showLoader, setShowLoader] = React.useState(false);
  const [selectedConsentApproval1, setConsentApproval1] = React.useState(false);
  const [selectedConsentApproval2, setConsentApproval2] = React.useState(false);
  const [selectedConsentApproval3, setConsentApproval3] = React.useState(false);
  const [selectedConsentApproval4, setConsentApproval4] = React.useState(false);
  const [selectedConsentApproval5, setConsentApproval5] = React.useState(false);
  const [selectedConsentApproval6, setConsentApproval6] = React.useState(false);
  const [benificieryName, setBenificieryName] = React.useState("");
  const [healtCareWorkerName, setHealthCareWorkerName] = React.useState("");
  const [selectedConsentApproval7, setConsentApproval7] = React.useState(false);
  const [modalData, setModalData] = React.useState("");
  const [modalState, setModalState] = React.useState(false);
  const [resendAadhaarOtpChance, setResendAadhaarOtpChance] = React.useState(0);
  const [resendMobileOtpChance, setResendMobileOtpChance] = React.useState(0);
  const [aadhaarOtpButtonText, setAadhaarOtpButtonText] =
    React.useState("RESEND OTP");
  const [mobileOtpbuttonText, setMobileOtpButtonText] =
    React.useState("RESEND OTP");
  const [intervalId, setIntervalId] = React.useState(null);

  //To send OTP to the mobile number registered with the given Aadhaar Number for New Abha Registration.
  const getAadhaarOtp = async () => {
    if (aadhaarId.trim() == "") {
      setModalData("Kindly enter your Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    if (aadhaarId.trim().length !== 12) {
      setModalData("Kindly enter a proper Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    if (aadhaarId.trim().match(/^[0-9]+$/) === null) {
      setModalData("Kindly enter a proper Aadhaar Number.");
      handleModalOpen();
      return false;
    }
    const __oo = { aadhaar: aadhaarId };
    setShowLoader(true);
    const res = await asyncPost(
      URI.generateAdhaarOTP,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status === 2000) {
      //debugger;
      setTxnId(res.data.txnId);
      console.log(res);
      handleNext();
      resendAadharOtpButtontext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (String(res.error).includes("Invalid LoginId")) {
        setModalData("Message from ABDM : Kindly enter proper Aadhaar Number.");
        handleModalOpen();
        return false;
      }
      if (String(res.error).includes("multiple OTPs")) {
        setModalData(
          "Message from ABDM : You have already requested OTP too many times. Try again after 30 minutes"
        );
        handleModalOpen();
        return false;
      }
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      }
    }
  };
  //To resend OTP to the aadhar registered mobile number
  const resendAadhaarOtp = async () => {
    setShowLoader(true);
    const res = await asyncPost(
      URI.generateAdhaarOTP,
      { aadhaar: aadhaarId },
      true,
      true,
      global.token
    );
    if (res.status == 2000) {
      resendAadharOtpButtontext();
      setTxnId(res.data.txnId);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        String(res.error).includes("The OTP that you have entered is incorrect")
      ) {
        setModalData("Message from ABDM : Kindly enter proper OTP.");
        handleModalOpen();
        return false;
      }
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      } else {
        setModalData(res.message);
        handleModalOpen();
      }
    }
  };

  const resendAadharOtpButtontext = () => {
    let count = parseInt(resendAadhaarOtpChance);
    let i = RESEND_OTP_TIMEOUT;
    if (i > 0) {
      const id = setInterval(() => {
        count >= RESEND_OTP_CHANCE
          ? setAadhaarOtpButtonText("CANNOT USE RESEND OTP")
          : setAadhaarOtpButtonText("RESEND OTP AFTER: " + i);
        i = i - 1;
        if (i < 0) {
          count++;
          i = RESEND_OTP_TIMEOUT;
          setResendAadhaarOtpChance(count.toString());
          count > RESEND_OTP_CHANCE
            ? setAadhaarOtpButtonText("CANNOT USE RESEND OTP")
            : setAadhaarOtpButtonText("RESEND OTP");
          clearInterval(id); // Clear interval using local variable
        }
      }, 1000);
      setIntervalId(id); // Save intervalId in state
    }
  };

  //To verify the OTP send while using the Aadhaar Number for new Abha registration
  const verifyAadhaarOtp = async () => {
    if (aadhaarOtp.trim() == "") {
      setModalData("Kindly Enter your OTP first.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo = {
      otp: aadhaarOtp,
      txnId: txnId,
    };
    // debugger;
    const res = await asyncPost(
      URI.verifyAadhaarOtp,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status == 2000) {
      //debugger;
      setTxnId(res.data.txnId);
      handleNext();
      clearInterval(intervalId);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        String(res.error).includes("The OTP that you have entered is incorrect")
      ) {
        setModalData("Message from ABDM : Kindly enter proper OTP.");
        handleModalOpen();
        return false;
      }
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      } else {
        setModalData("Message from ABDM : Unable to authenticate.");
        handleModalOpen();
        return false;
      }
    }
  };

  //To send OTP to user given mobile number
  const getMobileOtp = async () => {
    if (mobile.trim().length < 10) {
      setModalData("Please enter a valid mobile number");
      handleModalOpen();
      return false;
    }
    const regex = "^[0-9]*$";
    if (!mobile.trim().match(regex)) {
      setModalData("Please enter a valid mobile number");
      handleModalOpen();
      return false;
    }
    const __oo = {
      mobile: mobile,
      txnId: txnId,
    };
    setShowLoader(true);
    const res = await asyncPost(
      URI.generateMobileOtpForAadhaarRegistration,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status == 2000) {
      setTxnId(res.data.txnId);
      resendMobileOtpButtontext();
      handleNext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      } else {
        setShowLoader(false);
        setModalData(res.message);
        handleModalOpen();
      }
    }
  };
  //To resend OTP to the user given mobile number
  const resendMobileOtp = async () => {
    setShowLoader(true);
    const __oo = {
      mobile: mobile,
      txnId: txnId,
    };
    debugger;
    const res = await asyncPost(
      URI.generateMobileOtpForAadhaarRegistration,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status == 2000) {
      //debugger;
      resendMobileOtpButtontext();
      setTxnId(res.data.txnId);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      } else {
        setShowLoader(false);
        setModalData(res.message);
        handleModalOpen();
      }
    }
  };

  const resendMobileOtpButtontext = () => {
    let count = parseInt(resendMobileOtpChance);
    let i = RESEND_OTP_TIMEOUT;
    if (i > 0) {
      const id = setInterval(() => {
        count >= RESEND_OTP_CHANCE
          ? setMobileOtpButtonText("CANNOT USE RESEND OTP")
          : setMobileOtpButtonText("RESEND OTP AFTER: " + i);
        i = i - 1;
        if (i < 0) {
          count++;
          i = RESEND_OTP_TIMEOUT;
          setMobileOtpButtonText(count.toString());
          count > RESEND_OTP_CHANCE
            ? setMobileOtpButtonText("CANNOT USE RESEND OTP")
            : setMobileOtpButtonText("RESEND OTP");
          clearInterval(id); // Clear interval using local variable
        }
      }, 1000);
      setIntervalId(id); // Save intervalId in state
    }
  };

  //To verify the OTP send while using the Mobile Number for new Abha registration
  const verifyMobileOtp = async () => {
    if (mobileOtp.trim() == "") {
      setModalData("Kindly Enter your OTP first.");
      handleModalOpen();
      return false;
    }
    setShowLoader(true);
    const __oo = {
      otp: mobileOtp,
      txnId: txnId,
    };
    const res = await asyncPost(
      URI.verifyMobileOtpForAadhaarRegistration,
      __oo,
      true,
      true,
      global.token
    );
    if (res.status == 2000) {
      //debugger;
      setTxnId(res.data.txnId);
      handleNext();
      clearInterval(intervalId);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        String(res.error).includes("The OTP that you have entered is incorrect")
      ) {
        setModalData("Message from ABDM : Kindly enter proper OTP.");
        handleModalOpen();
        return false;
      }
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      } else {
        setModalData("Message from ABDM : Unable to authenticate.");
        handleModalOpen();
        return false;
      }
    }
  };

  //To generate ABHA ID
  const generateAbhaId = async () => {
    const regex = "^[a-zA-Z0-9_.]*$";
    if (healthId.trim().length < 8 && healthId.trim().length != 0) {
      setModalData(
        "Validation rules for ABHA Address:\n" +
          "1. Minimum length - 8 characters\n" +
          "2. Maximum length - 18 characters\n" +
          "3. Special characters allowed - 1 dot (.) and/or 1 underscore (_)\n" +
          "4. Special character dot and underscore should be in between. Special characters cannot be in the beginning or at the end\n" +
          "5. Alphanumeric - only numbers, only letters or any combination of numbers and letters is allowed."
      );
      handleModalOpen();
      return false;
    }
    if (
      healthId.trim().length >= 8 &&
      (healthId.trim().lastIndexOf(".") != healthId.trim().indexOf(".") ||
        healthId.trim().lastIndexOf("_") != healthId.trim().indexOf("_") ||
        healthId.trim().indexOf(".") === 0 ||
        healthId.trim().indexOf(".") === healthId.trim().length - 1 ||
        healthId.trim().indexOf("_") === 0 ||
        healthId.trim().indexOf("_") === healthId.trim().length - 1)
    ) {
      setModalData(
        "Validation rules for ABHA Address:\n" +
          "1. Minimum length - 8 characters\n" +
          "2. Maximum length - 18 characters\n" +
          "3. Special characters allowed - 1 dot (.) and/or 1 underscore (_)\n" +
          "4. Special character dot and underscore should be in between. Special characters cannot be in the beginning or at the end\n" +
          "5. Alphanumeric - only numbers, only letters or any combination of numbers and letters is allowed."
      );
      handleModalOpen();
      return false;
    }
    if (!healthId.trim().match(regex)) {
      setModalData(
        "Validation rules for ABHA Address:\n" +
          "1. Minimum length - 8 characters\n" +
          "2. Maximum length - 18 characters\n" +
          "3. Special characters allowed - 1 dot (.) and/or 1 underscore (_)\n" +
          "4. Special character dot and underscore should be in between. Special characters cannot be in the beginning or at the end\n" +
          "5. Alphanumeric - only numbers, only letters or any combination of numbers and letters is allowed."
      );
      handleModalOpen();
      return false;
    }

    setShowLoader(true);
    const __oo = {
      healthId: healthId,
      txnId: txnId,
    };
    // debugger;
    const res = await asyncPost(
      URI.generateAdhaarAbhaId,
      __oo,
      true,
      true,
      global.token
    );
    console.log("ABHA Response >>> " + JSON.stringify(res));
    if (res.status == 2000) {
      //debugger;
      setModalData("Your ABHA has been created successfully.");
      handleModalOpen();
      console.log(res);
      // setTxnId(res.data.txnId);
      setPatientName(res.data.name);
      setHealthIdRes(res.data.healthId);
      setHealthIdNoRes(res.data.healthIdNumber);
      setMobileRes(res.data.mobile);
      setKycPhotoRes(res.data.kycPhoto);
      setGenderRes(res.data.gender);
      setXToken(res.data.xtoken);
      setDobRes(res.data.dateOfBirth);
      console.log(
        "ABHA ID Data res.data.xToken>>> " + JSON.stringify(res.data.xtoken)
      );
      console.log("ABHA ID xToken>>> " + JSON.stringify(xToken));
      handleNext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      } else {
        setShowLoader(false);
        setModalData(res.message);
        handleModalOpen();
      }
    }
  };
  //To get the ABHA Health Card
  const getHealthCard = async () => {
    setShowLoader(true);
    const __oo = {
      txnId: txnId,
      token: xToken,
    };
    // debugger;
    const res = await asyncPost(URI.getPngCard, __oo, true, true, global.token);
    console.log("Health Card Response >>> " + JSON.stringify(res));
    if (res.status == 2000) {
      //debugger;
      setProfileImageRes(res.data);
      handleNext();
      setShowLoader(false);
    } else {
      setShowLoader(false);
      if (
        String(res.status).includes("504") ||
        String(res.status).includes("500")
      ) {
        setModalData("Server side error, please try again after sometime.");
        handleModalOpen();
        return false;
      } else {
        setShowLoader(false);
        setModalData(res.message);
        handleModalOpen();
      }
    }
  };

  const postMessageToParent = async () => {
    const __oo = {
      name: patientName,
      healthId: healthIdRes,
      healthIdNumber: healthIdNoRes,
      gender: genderRes,
      mobile: mobileRes,
      email: emailRes,
      isNew: true,
      yearOfBirth: dobres
        .trim()
        .substring(dobres.trim().length - 4, dobres.trim().length),
      pngCard: profileImageRes,
      aadhaarNumber: aadhaarId,
    };
    window.parent.postMessage(JSON.stringify(__oo), "*");
  };

  //This Event is trigerred from the parent web UI.
  window.addEventListener("message", function (event) {
    if (event.data === "closeWindow") {
      postMessageToParent();
    }
  });
  //This async function post data from react to the parent(vendor) component which calls the react application in an iFrame
  const backToHome = async () => {
    postMessageToParent();
    setActiveStep(0);
    resetHooks();
  };
  const resetHooks = async () => {
    setMobileOtp("");
    setMobile("");
    setTxnId("");
    setAadhaarOtp("");
    setAadhaarId("");
    setResendMobileOtpChance(1);
    setResendAadhaarOtpChance(1);
  };
  //FOr downloading the card
  const downloadPng = async () => {
    // window.location.href = 'data:application/octet-stream;base64,' + profileImageRes;
    var a = document.createElement("a"); //Create <a>
    a.href = "data:image/png;base64," + profileImageRes; //Image Base64 Goes here
    a.download = "HealthCard.png"; //File name Here
    a.click(); //Downloaded file
  };

  const handleAadhaarId = (value) => {
    var naturalNumberRegex = /^\d*$/; // Allows only digits or empty string
    if (value.match(naturalNumberRegex)) {
      setAadhaarId(value);
    } else {
      setAadhaarId(""); // Clear the input if it doesn't match the regex
    }
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const handleModalOpen = () => {
    setModalState(true);
  };
  const handleModalClose = () => {
    setModalState(false);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleShowAadhaar = () => {
    setShowAadhaar(!showAadhaar);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const checkBoxApproval1 = () => {
    setConsentApproval1(!selectedConsentApproval1);
  };
  const checkBoxApproval2 = () => {
    setConsentApproval2(!selectedConsentApproval2);
  };
  const checkBoxApproval3 = () => {
    setConsentApproval3(!selectedConsentApproval3);
  };
  const checkBoxApproval4 = () => {
    setConsentApproval4(!selectedConsentApproval4);
  };
  const checkBoxApproval5 = () => {
    setConsentApproval5(!selectedConsentApproval5);
    //setConsentApproval6(!selectedConsentApproval6);
    setConsentApproval7(!selectedConsentApproval7);
  };
  const checkBoxApproval6 = () => {
    setConsentApproval6(!selectedConsentApproval6);
  };
  // const checkBoxApproval7 = () => {
  //   setConsentApproval7(!selectedConsentApproval7);
  // };

  const generateScreen = () => {
    if (activeStep == 0) {
      return populateScreenFlowOne(); // Get OTP for AADHAAR
    } else if (activeStep == 1) {
      return populateScreenFlowTwo(); // Verify OTP for AADHAAR
    } else if (activeStep == 2) {
      return populateScreenFlowThree(); // Enter mobile
    } else if (activeStep == 3) {
      return populateScreenFlowFour(); // validate mobile OTP
    } else if (activeStep == 4) {
      return populateScreenFlowFive(); //  choose health ID
    } else if (activeStep == 5) {
      return populateScreenFlowSix(); //display HealthID details
    } else if (activeStep == 6) {
      return populateScreenFlowSeven(); //display HealthID Card
    }
  };

  const populateScreenFlowOne = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid
          container
          direction={"row"}
          spacing={5}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <TextField
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowAadhaar} edge="end">
                      {showAadhaar ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              value={aadhaarId}
              autoFocus
              id="aadhaarId"
              label="Aadhaar Id"
              variant="standard"
              type={showAadhaar ? "text" : "password"}
              style={{ marginTop: -5 }}
              onChange={(e) => handleAadhaarId(e.target.value)}
              inputProps={{ maxLength: 12 }}
            />
          </Grid>
          <Grid item>
            {global.user == "" ? (
              <Button
                type="button"
                fullWidth
                variant="contained"
                style={{
                  backgroundColor:
                    selectedConsentApproval1 &&
                    selectedConsentApproval2 &&
                    selectedConsentApproval3 &&
                    selectedConsentApproval4 &&
                    selectedConsentApproval5 &&
                    selectedConsentApproval7 &&
                    benificieryName.trim() != ""
                      ? global.secondaryColour
                      : "#ccc",
                  color: "#fff",
                  paddingBottom: 10,
                }}
                className={classes.submit}
                onClick={() => getAadhaarOtp()}
                disabled={
                  selectedConsentApproval1 &&
                  selectedConsentApproval2 &&
                  selectedConsentApproval3 &&
                  selectedConsentApproval4 &&
                  selectedConsentApproval5 &&
                  selectedConsentApproval7 &&
                  benificieryName.trim() != ""
                    ? false
                    : true
                }
              >
                Get OTP
              </Button>
            ) : (
              <Button
                type="button"
                fullWidth
                variant="contained"
                style={{
                  backgroundColor:
                    selectedConsentApproval1 &&
                    selectedConsentApproval2 &&
                    selectedConsentApproval3 &&
                    selectedConsentApproval4 &&
                    selectedConsentApproval5 &&
                    selectedConsentApproval7 &&
                    benificieryName.trim() != ""
                      ? global.secondaryColour
                      : "#ccc",
                  color: "#fff",
                  paddingBottom: 10,
                }}
                className={classes.submit}
                onClick={() => getAadhaarOtp()}
                disabled={
                  selectedConsentApproval1 &&
                  selectedConsentApproval2 &&
                  selectedConsentApproval3 &&
                  selectedConsentApproval4 &&
                  selectedConsentApproval5 &&
                  selectedConsentApproval7 &&
                  benificieryName.trim() != ""
                    ? false
                    : true
                }
              >
                Get OTP
              </Button>
            )}
          </Grid>
        </Grid>
        <span style={{ fontSize: "0.7rem" }}>I hereby declare that:</span>
        <div id="consent_div" style={{ marginTop: 10 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedConsentApproval1 ? true : false}
                onChange={() => {
                  checkBoxApproval1();
                }}
                name="selectedConsentApproval1"
              />
            }
            label={
              <p
                style={{
                  fontSize: "0.7rem",
                }}
              >
                I am voluntarily sharing my Aadhaar Number / Virtual ID issued
                by the Unique Identification Authority of India (“
                <strong>UIDAI</strong>”), and my demographic information for the
                purpose of creating an Ayushman Bharat Health Account number (“
                <strong>ABHA number</strong>”) and Ayushman Bharat Health
                Account address (“<strong>ABHA Address</strong>”). I authorize
                NHA to use my Aadhaar number / Virtual ID for performing Aadhaar
                based authentication with UIDAI as per the provisions of the
                Aadhaar (Targeted Delivery of Financial and other Subsidies,
                Benefits and Services) Act, 2016 for the aforesaid purpose. I
                understand that UIDAI will share my e-KYC details, or response
                of “Yes” with NHA upon successful authentication.
              </p>
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedConsentApproval2 ? true : false}
                onChange={() => {
                  checkBoxApproval2();
                }}
                name="selectedConsentApproval2"
              />
            }
            label={
              <p style={{ fontSize: "0.7rem" }}>
                I intend to create Ayushman Bharat Health Account Number (“
                <strong>ABHA number</strong>”) and Ayushman Bharat Health
                Account address (“<strong>ABHA Address</strong>”) using document
                other than Aadhaar.
              </p>
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedConsentApproval3 ? true : false}
                onChange={() => {
                  checkBoxApproval3();
                }}
                name="selectedConsentApproval3"
              />
            }
            label={
              <p style={{ fontSize: "0.7rem" }}>
                I consent to usage of my ABHA address and ABHA number for
                linking of my legacy (past) health records and those which will
                be generated during this encounter.
              </p>
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedConsentApproval4 ? true : false}
                onChange={() => {
                  checkBoxApproval4();
                }}
                name="selectedConsentApproval4"
              />
            }
            label={
              <p style={{ fontSize: "0.7rem" }}>
                I authorize the sharing of all my health records with healthcare
                provider(s) for the purpose of providing healthcare services to
                me during this encounter.
              </p>
            }
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedConsentApproval5 ? true : false}
                onChange={() => {
                  checkBoxApproval5();
                }}
                name="selectedConsentApproval5"
              />
            }
            label={
              <p style={{ fontSize: "0.7rem" }}>
                I consent to the anonymization and subsequent use of my health
                records for public health purposes.
              </p>
            }
          />

          {global.user == "" ? (
            <FormControlLabel
              style={{ marginLeft: 20 }}
              control={
                <Checkbox
                  checked={selectedConsentApproval6 ? true : false}
                  onChange={() => {
                    checkBoxApproval6();
                  }}
                  name="selectedConsentApproval6"
                />
              }
              label={
                <p style={{ fontSize: "0.7rem" }}>
                  I,{" "}
                  <TextField
                    placeholder="healthcare worker name"
                    onChange={(e) => setHealthCareWorkerName(e.target.value)}
                  />
                  , confirm that I have duly informed and explained the
                  beneficiary of the contents of consent for aforementioned
                  purposes.
                </p>
              }
            />
          ) : (
            <FormControlLabel
              style={{ marginLeft: 20 }}
              control={
                <Checkbox
                  checked={selectedConsentApproval6 ? true : false}
                  onChange={() => {
                    checkBoxApproval6();
                  }}
                  name="selectedConsentApproval6"
                />
              }
              label={
                <p style={{ fontSize: "0.7rem" }}>
                  I,{" "}
                  <TextField
                    placeholder="healthcare worker name"
                    disabled={true}
                    value={global.user}
                  />
                  , confirm that I have duly informed and explained the
                  beneficiary of the contents of consent for aforementioned
                  purposes.
                </p>
              }
            />
          )}

          {global.benificiaryName === "" ? (
            <FormControlLabel
              style={{ marginLeft: 20 }}
              control={
                <Checkbox
                  checked={selectedConsentApproval7 ? true : false}
                  // onChange={() => {
                  //   checkBoxApproval7();
                  // }}
                  name="selectedConsentApproval7"
                />
              }
              label={
                <p style={{ fontSize: "0.7rem" }}>
                  I,{" "}
                  <TextField
                    placeholder="beneficiary name"
                    onChange={(e) => setBenificieryName(e.target.value)}
                  />
                  , have been explained about the consent as stated above and
                  hereby provide my consent for the aforementioned purposes.
                </p>
              }
            />
          ) : (
            <FormControlLabel
              style={{ marginLeft: 20 }}
              control={
                <Checkbox
                  checked={selectedConsentApproval5 ? true : false}
                  // onChange={() => {
                  //   checkBoxApproval7();
                  // }}
                  name="selectedConsentApproval7"
                />
              }
              label={
                <p style={{ fontSize: "0.7rem" }}>
                  I,{" "}
                  <TextField
                    placeholder="beneficiary name"
                    value={global.benificiaryName}
                    disabled={true}
                  />
                  , have been explained about the consent as stated above and
                  hereby provide my consent for the aforementioned purposes.
                </p>
              }
            />
          )}
        </div>
      </form>
    );
  };

  const populateScreenFlowTwo = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid
          container
          direction={"row"}
          spacing={1}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <TextField
              variant="standard"
              label="Enter OTP"
              required
              id="aadhaarOtp"
              inputProps={{ maxLength: 6 }}
              value={aadhaarOtp}
              type="text"
              autoComplete="off"
              onChange={(e) => setAadhaarOtp(e.target.value)}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              style={{ paddingBottom: 10, marginTop: 7 }}
              onClick={() => verifyAadhaarOtp()}
            >
              Verify & Proceed
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              style={{ paddingBottom: 10, marginTop: 7 }}
              disabled={aadhaarOtpButtonText === "RESEND OTP" ? false : true}
              onClick={() => resendAadhaarOtp()}
            >
              {aadhaarOtpButtonText}
            </Button>
          </Grid>
          <Grid item>
            <item
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {resendAadhaarOtpChance === 3 ? (
                ""
              ) : (
                <span>
                  You can resend OTP{" "}
                  <span style={{ color: "#D20062" }}>
                    {resendAadhaarOtpChance > 0
                      ? parseInt(RESEND_OTP_CHANCE) -
                        parseInt(resendAadhaarOtpChance) +
                        1
                      : 2}
                  </span>{" "}
                  more times
                </span>
              )}
            </item>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowThree = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid container direction={"row"} spacing={2}>
          <Grid item>
            <TextField
              variant="standard"
              id="mobile"
              value={mobile}
              label="Enter Mobile Number"
              inputProps={{ maxLength: 10 }}
              type="text"
              onChange={(e) => setMobile(e.target.value)}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              style={{ paddingBottom: 10, marginTop: 7 }}
              onClick={() => getMobileOtp()}
            >
              Get OTP
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowFour = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid
          container
          direction={"row"}
          spacing={1}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <TextField
              variant="standard"
              id="mobileOtp"
              inputProps={{ maxLength: 6 }}
              value={mobileOtp}
              label="Enter OTP"
              autoComplete="off"
              type="text"
              onChange={(e) => setMobileOtp(e.target.value)}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              style={{ paddingBottom: 10, marginTop: 7 }}
              onClick={() => verifyMobileOtp()}
            >
              Verify & Proceed
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              style={{ paddingBottom: 10, marginTop: 7 }}
              onClick={() => resendMobileOtp()}
              disabled={mobileOtpbuttonText === "RESEND OTP" ? false : true}
            >
              {mobileOtpbuttonText}
            </Button>
          </Grid>
          <Grid item>
            <item
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {resendMobileOtpChance === 3 ? (
                ""
              ) : (
                <span>
                  You can resend OTP{" "}
                  <span style={{ color: "#D20062" }}>
                    {resendMobileOtpChance > 0
                      ? parseInt(RESEND_OTP_CHANCE) -
                        parseInt(resendMobileOtpChance) +
                        1
                      : 2}
                  </span>{" "}
                  more times
                </span>
              )}
            </item>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowFive = () => {
    return (
      <form className={classes.form} noValidate>
        <Grid
          container
          direction={"column"}
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item>
            <TextField
              variant="standard"
              id="healthId"
              value={healthId}
              inputProps={{ maxLength: 18 }}
              label="ABHA Id"
              style={{ width: 500 }}
              type="text"
              autoComplete="off"
              onChange={(e) => setHealthId(e.target.value)}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              style={{ paddingBottom: 10, marginTop: 7 }}
              onClick={() => generateAbhaId()}
            >
              Generate ABHA
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  };

  const populateScreenFlowSix = () => {
    const kycPhotoI = "data:image/png;base64, " + kycPhotoRes;
    return (
      <Table size="big">
        <TableBody>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Number</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{healthIdNoRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>ABHA Address</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{healthIdRes}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Name</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{patientName}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Gender</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>
              {genderRes == "M" ? "Male" : "Female"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Mobile</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{mobileRes}</TableCell>
            <TableCell style={{ textAlign: "left" }}>
              <strong>Date of Birth</strong>
            </TableCell>
            <TableCell style={{ textAlign: "left" }}>{dobres}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} className="imgcontainer">
              <img src={kycPhotoI} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={4} style={{ textAlign: "center" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => getHealthCard()}
              >
                View ABHA Card
              </Button>
              <Button
                variant="contained"
                className="mx-2"
                color="primary"
                onClick={() => backToHome()}
              >
                Back To Home
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  };

  const populateScreenFlowSeven = () => {
    const profileImageI = "data:image/png;base64, " + profileImageRes;
    return (
      <div className="imgcontainer">
        <img src={profileImageI} />

        <div style={{ textAlign: "center" }} className="my-2">
          <Button
            variant="contained"
            className="mx-2"
            color="primary"
            onClick={() => backToHome()}
          >
            Back To Home
          </Button>
          <Button
            variant="contained"
            className="mx-2"
            color="primary"
            onClick={() => downloadPng()}
          >
            Download ABHA Card
          </Button>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper} style={{ padding: "10px" }}>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {/* {generateScreen()} */}
            {showLoader ? (
              <div style={{ textAlign: "center", marginTop: 60 }}>
                <CircularProgress />
                <h5 style={{ marginTop: 5 }}>Loading...</h5>
              </div>
            ) : (
              generateScreen()
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                pt: 2,
                marginRight: 20,
              }}
            >
              {/* <Button
                            color="inherit"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            Back
                        </Button> */}

              {/* <Button onClick={handleNext}>
                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                        </Button> */}
            </Box>
          </React.Fragment>
        )}
      </Paper>
      <Modal
        open={modalState}
        onClose={() => handleModalClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalState}>
          <Box
            className={classes.modalStyle}
            style={{
              background: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 10,
              padding: "15px",
            }}
          >
            <h5 id="transition-modal-title">Information</h5>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <pre>{modalData}</pre>
            </Typography>
            <Button
              variant="contained"
              color="primary"
              style={{ paddingBottom: 10, marginTop: 7 }}
              onClick={() => handleModalClose()}
            >
              OK
            </Button>
          </Box>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}
